// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {findMatchingAccount} from '../../shared/services/claim-shared-helper';

export const updateNonTrackedPinModalPin = pin =>

    dispatch =>

        dispatch({
            pin,
            type: actions.UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_PIN
        });

export const updateNonTrackedPinModalAccount = (dealer, dealers) => ({
    account: findMatchingAccount(dealer, dealers).account,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_ACCOUNT
});

export const updateNonTrackedPinModalFailureDate = failureDate => ({
    failureDate,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_FAILURE_DATE
});

export const updateNonTrackedPinModalInvoiceNumber = invoiceNumber => ({
    invoiceNumber,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_INVOICE_NUMBER
});

export const updateNonTrackedPinModalInvoiceDate = invoiceDate => ({
    invoiceDate,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_INVOICE_DATE
});



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/pin.js